import { FETCH_MATERIALS } from "actions";

const INITIAL_STATE = {};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_MATERIALS:
      return action.payload || {};
    default:
      return state;
  }
}
